import { lib } from '@gocanvas/client'
const {
  LOOP_SHEET_TYPE_IDS,
  LABELS_ABOVE_SHEET_TYPE_ID,
  LABELS_LEFT_SHEET_TYPE_ID,
} = lib 

export const isStandardScreen = ({ sheet_type_id }) => {
  return [LABELS_ABOVE_SHEET_TYPE_ID, LABELS_LEFT_SHEET_TYPE_ID].includes(
    sheet_type_id
  )
}

// Returns true if it's a table, loop, or advanced loop screen
export const isLoopScreen = ({ sheet_type_id }) => {
  return LOOP_SHEET_TYPE_IDS.includes(sheet_type_id)
}

// Recursive function to find all nested child sheets for a given sheet that has a multi_section
export const findChildSheets = (sheets, multiSectionId) => {
  const children = sheets.filter(sheet => sheet.section_id === multiSectionId)
  const grandChildren = children
      .filter(({ multi_section }) => multi_section)
      .flatMap(child => findChildSheets(sheets, child.multi_section))

  return [...children, ...grandChildren]
}
